import { createAction } from 'redux-actions';

export const updateBasename = createAction('UPDATE_BASENAME');
export const updateHub = createAction('UPDATE_HUB');
